import { render, staticRenderFns } from "./Adm_funciones.vue?vue&type=template&id=2542b0a2"
import script from "./Adm_funciones.vue?vue&type=script&lang=js"
export * from "./Adm_funciones.vue?vue&type=script&lang=js"
import style0 from "./Adm_funciones.vue?vue&type=style&index=0&id=2542b0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports